import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Select } from 'antd';
import { ApplicationDefinitionConditionalEditStore } from '../../stores';

const FIXED_TABS_BEFORE_GROUPS = 2;

interface Props {
    store: ApplicationDefinitionConditionalEditStore;
}

const TabImportDialogs: React.FC<Props> = ({ store }) => {
    const tabImport = store.tabImport;
    const destinationLabel = (inputGroupId: string, name: string) => {
        const displayedIndex = store.inputGroups.findIndex(group => group.inputGroupId === inputGroupId);
        if (displayedIndex >= 0) {
            return `${name} (tab ${displayedIndex + FIXED_TABS_BEFORE_GROUPS + 1})`;
        }
        const savedIndex = store.applicationDefinition?.inputGroups.findIndex(
            group => group.inputGroupId === inputGroupId
        );
        return savedIndex !== undefined && savedIndex >= 0 ? `${name} (saved group ${savedIndex + 1})` : name;
    };

    return (
        <>
            <Modal
                visible={tabImport.isConfirmVisible}
                title="Replace current tab configuration?"
                okText="Replace configuration"
                cancelText="Cancel"
                confirmLoading={tabImport.isImporting}
                cancelButtonProps={{ disabled: tabImport.isImporting }}
                closable={!tabImport.isImporting}
                maskClosable={!tabImport.isImporting}
                onOk={tabImport.confirm}
                onCancel={tabImport.cancel}
            >
                Importing this file will replace all existing configuration in this tab.
            </Modal>
            <Modal
                visible={tabImport.isMappingVisible}
                title="Map Conditions input groups"
                okText="Validate mapping"
                cancelText="Cancel"
                confirmLoading={tabImport.isImporting}
                okButtonProps={{
                    disabled: tabImport.mappings.some(mapping => !tabImport.selectedMappings[mapping.reference])
                }}
                cancelButtonProps={{ disabled: tabImport.isImporting }}
                closable={!tabImport.isImporting}
                maskClosable={!tabImport.isImporting}
                onOk={tabImport.confirmMappings}
                onCancel={tabImport.cancel}
            >
                <p>Select a compatible saved destination group for each reference.</p>
                {tabImport.mappings.map(mapping => (
                    <div key={mapping.reference} style={{ marginBottom: 16 }}>
                        <label htmlFor={`tab-import-${mapping.reference}`}>
                            {mapping.name} ({mapping.structureType})
                        </label>
                        <Select
                            id={`tab-import-${mapping.reference}`}
                            style={{ width: '100%' }}
                            placeholder="Select destination group"
                            value={tabImport.selectedMappings[mapping.reference]}
                            disabled={tabImport.isImporting}
                            onChange={value => tabImport.setMapping(mapping.reference, value)}
                        >
                            {mapping.candidates.map(candidate => (
                                <Select.Option key={candidate.inputGroupId} value={candidate.inputGroupId}>
                                    {destinationLabel(candidate.inputGroupId, candidate.name)}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                ))}
            </Modal>
        </>
    );
};

export default observer(TabImportDialogs);
